import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthTest: React.FC = () => {
  const { user, profile, isAuthenticated, isLoading, loginWithGoogle, logout } = useAuth();

  const handleLogin = async () => {
    try {
      console.log('Starting login...');
      await loginWithGoogle();
      console.log('Login completed');
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleLogout = async () => {
    try {
      console.log('Starting logout...');
      await logout();
      console.log('Logout completed');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f0f0', 
      padding: '2rem',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ 
        maxWidth: '600px', 
        margin: '0 auto', 
        backgroundColor: 'white', 
        padding: '2rem', 
        borderRadius: '8px', 
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          fontSize: '2rem', 
          fontWeight: 'bold', 
          color: '#333', 
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          Authentication Test
        </h1>

                 {/* Status */}
         <div style={{ 
           marginBottom: '2rem', 
           padding: '1rem', 
           backgroundColor: '#f8f9fa', 
           borderRadius: '6px' 
         }}>
           <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
             Status:
           </h2>
           <p><strong>Loading:</strong> {isLoading ? 'Yes' : 'No'}</p>
           <p><strong>Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
           <p><strong>Google Client ID:</strong> {import.meta.env.VITE_GOOGLE_CLIENT_ID ? 'Configured' : 'Not configured'}</p>
           <p><strong>Mode:</strong> {import.meta.env.VITE_GOOGLE_CLIENT_ID && import.meta.env.VITE_GOOGLE_CLIENT_ID !== 'test-client-id' ? 'Real Google OAuth' : 'Mock Mode'}</p>
           {user && (
             <>
               <p><strong>User:</strong> {user.name}</p>
               <p><strong>Email:</strong> {user.email}</p>
             </>
           )}
           {profile && (
             <>
               <p><strong>Profile:</strong> {profile.fullName}</p>
             </>
           )}
         </div>

        {/* Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '1rem', 
          justifyContent: 'center', 
          flexWrap: 'wrap' 
        }}>
          {!isAuthenticated ? (
            <button 
              onClick={handleLogin}
              disabled={isLoading}
              style={{ 
                padding: '0.75rem 1.5rem', 
                backgroundColor: isLoading ? '#ccc' : '#e65100', 
                color: 'white', 
                border: 'none', 
                borderRadius: '6px',
                fontWeight: '500',
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
                         >
               {isLoading ? 'Đang đăng nhập...' : 
                 import.meta.env.VITE_GOOGLE_CLIENT_ID && import.meta.env.VITE_GOOGLE_CLIENT_ID !== 'test-client-id' 
                   ? 'Đăng nhập với Google' 
                   : 'Đăng nhập với Google (Mock)'}
             </button>
          ) : (
            <button 
              onClick={handleLogout}
              style={{ 
                padding: '0.75rem 1.5rem', 
                backgroundColor: '#dc3545', 
                color: 'white', 
                border: 'none', 
                borderRadius: '6px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
            >
              Đăng xuất
            </button>
          )}
        </div>

        {/* Navigation */}
        <div style={{ 
          marginTop: '2rem', 
          textAlign: 'center' 
        }}>
          <a 
            href="/" 
            style={{ 
              color: '#007bff', 
              textDecoration: 'none',
              marginRight: '1rem'
            }}
          >
            ← Về trang chủ
          </a>
          <a 
            href="/test-auth" 
            style={{ 
              color: '#007bff', 
              textDecoration: 'none'
            }}
          >
            Test Auth Page
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthTest;
